export type BrowserType = 'chrome' | 'edge' | 'firefox' | 'safari' | 'other';

export function detectBrowser(): BrowserType {
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes('edg/')) return 'edge';
  if (ua.includes('chrome') && !ua.includes('edg/')) return 'chrome';
  if (ua.includes('firefox')) return 'firefox';
  if (ua.includes('safari') && !ua.includes('chrome')) return 'safari';
  return 'other';
}

export function isChromiumBased(): boolean {
  const browser = detectBrowser();
  return browser === 'chrome' || browser === 'edge';
}

export function getBrowserDisplayName(browser: BrowserType): string {
  const names: Record<BrowserType, string> = {
    chrome: 'Chrome',
    edge: 'Edge',
    firefox: 'Firefox',
    safari: 'Safari',
    other: 'your browser'
  };
  return names[browser];
}
